<template>
    <div
        class="highlight-box w-mc px-1 fw-600 light-light-color"
        style="padding-top: 2px; padding-bottom: 2px; display: inline-block"
        :class="[`highlight-bg-${color}`, {'fs-13': isApp(), 'fs-11': !isApp()}, isReduced ? 'reduced' : '']"
    >
        <slot/>
    </div>
</template>

<script setup lang="ts">
import { isApp } from "@/functions/enviroment";

import { HIGHLIGHT_COLOR } from "@/types/enum/propEnum";
import { HighlightBoxProps } from "@/types/props";

withDefaults(defineProps<HighlightBoxProps>(), {
    color: HIGHLIGHT_COLOR.PURPLE
})
</script>

<style scoped>
.highlight-box {
    display: inline-block;
    border-radius: 16px;
    padding-top: 2px;
    padding-bottom: 2px;
}

.reduced {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}
</style>
